"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _Alert = _interopRequireDefault(require("./Alert"));

var _useEmail2 = _interopRequireDefault(require("./hooks/useEmail"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {}
  };
});

var ShareDialog = function ShareDialog(_ref) {
  var open = _ref.open,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'download' : _ref$variant,
      resolve = _ref.resolve,
      reject = _ref.reject,
      handle = _ref.handle;

  var _useTranslation = (0, _reactI18next.useTranslation)(['account', 'core']),
      t = _useTranslation.t;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      shared = _useState2[0],
      setShared = _useState2[1];

  var cancel = function cancel() {
    reject();
    handle({
      open: false
    });
  };

  var confirm = function confirm(m) {
    resolve(m);
    handle({
      open: false
    });
  };

  return /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
    open: open,
    onClose: cancel
  }, /*#__PURE__*/_react["default"].createElement(_core.DialogTitle, null, t('acl.share.title')), /*#__PURE__*/_react["default"].createElement(_core.DialogContent, null, /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Box, null, variant === 'download' ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, "Om dit document te kunnen downloaden, moet u hiervoor eerst uw gegevens delen met de fabrikant. Zodra u toestemming geeft, kan u documenten van de fabrikant downloaden. De fabrikant ontvangt hiervoor in ruil uw persoonlijke gegevens zoals e-mail voor- en achternaam en de naam van het bedrijf dat u vertegenwoordigt.") : /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, "Wanneer u favorieten opslaat, vragen wij om uw contactgegevens (voornaam, achternaam, bedrijfsnaam en e-mail) te delen met de fabrikant. Zo kan de fabrikant zien welke producten u interesseren en vrijblijvend met u contact opnemen.")), /*#__PURE__*/_react["default"].createElement(_core.Box, null, /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
      checked: shared,
      onChange: function onChange(event) {
        return setShared(event.target.checked);
      },
      name: "shareProfile"
    }),
    label: "Ja, mijn gegevens mogen gedeeld worden."
  })))), /*#__PURE__*/_react["default"].createElement(_core.DialogActions, null, variant === 'download' ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: cancel
  }, t('core:actions.cancel')), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: confirm,
    color: "primary",
    variant: "outlined",
    disabled: !shared
  }, t('core:actions.ok'))) : /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: function onClick() {
      return shared ? confirm() : cancel();
    },
    color: "primary",
    variant: "outlined"
  }, t('core:actions.ok'))));
};

var RequestDialog = function RequestDialog(_ref2) {
  var open = _ref2.open,
      resolve = _ref2.resolve,
      reject = _ref2.reject,
      handle = _ref2.handle;

  var cancel = function cancel() {
    reject();
    handle({
      open: false
    });
  };

  var confirm = function confirm(m) {
    resolve(m);
    handle({
      open: false
    });
  };

  return /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
    open: open,
    onClose: cancel
  }, /*#__PURE__*/_react["default"].createElement(_core.DialogTitle, null, "Vraag toegang aan"), /*#__PURE__*/_react["default"].createElement(_core.DialogContent, null, /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    title: "Dit bestand is enkel toegankelijk op aanvraag",
    variant: "warning",
    message: "Om toegang te krijgen op dit document, moet u hiervoor eerst een aanvraag opstarten bij de fabrikant."
  }), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    style: {
      marginTop: 16,
      marginBottom: 8
    }
  }, "Zodra uw aanvraag werd behandeld, ontvangt u hierover een e-mail en kan u de afgeschermde documenten binnen dit certificaat bekijken.")), /*#__PURE__*/_react["default"].createElement(_core.DialogActions, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: cancel
  }, "annuleren"), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: confirm,
    color: "primary",
    variant: "outlined"
  }, "aanvragen")));
};

var OnboardingDialog = function OnboardingDialog(_ref3) {
  var open = _ref3.open,
      onClose = _ref3.onClose,
      tokenMailSent = _ref3.tokenMailSent,
      registrationComplete = _ref3.registrationComplete,
      customOnboardingMessage = _ref3.customOnboardingMessage,
      onboardingError = _ref3.onboardingError,
      onRegister = _ref3.onRegister,
      onLogin = _ref3.onLogin;
  var classes = useStyles();

  var _useEmail = (0, _useEmail2["default"])(),
      email = _useEmail.email,
      setEmail = _useEmail.setEmail,
      isValid = _useEmail.isValid;

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      registration = _useState4[0],
      setRegistration = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = _slicedToArray(_useState5, 2),
      firstName = _useState6[0],
      setFirstName = _useState6[1];

  var _useState7 = (0, _react.useState)(''),
      _useState8 = _slicedToArray(_useState7, 2),
      lastName = _useState8[0],
      setLastName = _useState8[1];

  var _useState9 = (0, _react.useState)(),
      _useState10 = _slicedToArray(_useState9, 2),
      company = _useState10[0],
      setCompany = _useState10[1];

  var isValidRegistration = isValid && firstName.length > 0 && lastName.length > 0;
  return /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
    onClose: onClose,
    "aria-labelledby": "simple-dialog-title",
    open: open,
    classes: {
      paper: classes.dialog
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.DialogTitle, null, registration ? 'Maak een account bij Probeton' : 'Aanmelden bij Probeton'), /*#__PURE__*/_react["default"].createElement(_core.DialogContent, null, tokenMailSent && /*#__PURE__*/_react["default"].createElement(_core.Typography, null, "Er werd een mail gestuurd met een magische link om aan te melden. Deze link blijft slechts 15 minuten geldig."), registrationComplete && /*#__PURE__*/_react["default"].createElement(_core.Typography, null, "Je registratie werd voltooid. Er werd een mail gestuurd om je email adres te bevestigen en je account te activeren. Gebruik deze link om aan te melden."), !tokenMailSent && !registrationComplete && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, customOnboardingMessage && /*#__PURE__*/_react["default"].createElement(_Alert["default"], customOnboardingMessage), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    style: {
      marginTop: 16,
      marginBottom: 8
    }
  }, registration ? 'Registreer je account op het Probeton extranet.' : 'Je bent niet aangemeld. Gelieve eerst aan te melden.'), registration ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: function onClick() {
      return setRegistration(false);
    }
  }, "Heb je reeds een account? Dan kan je hier aanmelden") : /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: function onClick() {
      return setRegistration(true);
    }
  }, "Heb je nog geen account? Dan kan je hier registreren."), /*#__PURE__*/_react["default"].createElement(_core.TextField, {
    name: "email",
    id: "email",
    fullWidth: true,
    margin: "normal",
    variant: "outlined",
    label: 'email address',
    error: !!onboardingError,
    helperText: onboardingError || '',
    autoFocus: true,
    required: true,
    value: email,
    onChange: function onChange(e) {
      return setEmail(e.target.value);
    }
  }), registration ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.TextField, {
    name: "firstName",
    id: "firstName",
    fullWidth: true,
    margin: "normal",
    variant: "outlined",
    label: "Voornaam",
    required: true,
    value: firstName,
    onChange: function onChange(e) {
      return setFirstName(e.target.value);
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.TextField, {
    name: "lastName",
    id: "lastName",
    fullWidth: true,
    margin: "normal",
    variant: "outlined",
    label: "Achternaam",
    required: true,
    value: lastName,
    onChange: function onChange(e) {
      return setLastName(e.target.value);
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.TextField, {
    name: "company",
    id: "company",
    fullWidth: true,
    margin: "normal",
    variant: "outlined",
    label: "Bedrijf",
    value: company,
    onChange: function onChange(e) {
      return setCompany(e.target.value);
    }
  })) : '')), /*#__PURE__*/_react["default"].createElement(_core.DialogActions, null, !tokenMailSent && !registrationComplete ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    className: classes.button,
    variant: "flat",
    type: "submit",
    onClick: onClose
  }, "annuleren"), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flexGrow: 1
    }
  }), registration ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
    className: classes.button,
    variant: "flat",
    color: "primary",
    type: "submit",
    disabled: !isValidRegistration,
    onClick: function onClick() {
      return onRegister({
        email: email,
        firstName: firstName,
        lastName: lastName,
        company: company
      });
    }
  }, "registreren") : /*#__PURE__*/_react["default"].createElement(_core.Button, {
    className: classes.button,
    variant: "outlined",
    color: "primary",
    type: "submit",
    disabled: !isValid,
    onClick: function onClick() {
      return onLogin(email);
    }
  }, "aanmelden")) : /*#__PURE__*/_react["default"].createElement(_core.Button, {
    className: classes.button,
    variant: "flat",
    color: "primary",
    type: "submit",
    onClick: onClose
  }, "ok")));
};

var ACLDialogs = function ACLDialogs(_ref4) {
  var onRegister = _ref4.onRegister,
      onLogin = _ref4.onLogin,
      aclProps = _ref4.aclProps,
      aclDispatchProps = _ref4.aclDispatchProps;
  var onboardingDialogOpen = aclProps.onboardingDialogOpen,
      customOnboardingMessage = aclProps.customOnboardingMessage,
      onboardingError = aclProps.onboardingError,
      registrationComplete = aclProps.registrationComplete,
      tokenMailSent = aclProps.tokenMailSent,
      shareProfileDialogOpen = aclProps.shareProfileDialogOpen,
      requestDialogOpen = aclProps.requestDialogOpen,
      requestPendingDialogOpen = aclProps.requestPendingDialogOpen,
      noAccessDialogOpen = aclProps.noAccessDialogOpen;
  var setOnboardingDialogOpen = aclDispatchProps.setOnboardingDialogOpen,
      setOnboardingError = aclDispatchProps.setOnboardingError,
      setTokenMailSent = aclDispatchProps.setTokenMailSent,
      setRegistrationComplete = aclDispatchProps.setRegistrationComplete,
      setShareProfileDialogOpen = aclDispatchProps.setShareProfileDialogOpen,
      setRequestDialogOpen = aclDispatchProps.setRequestDialogOpen,
      setRequestPendingDialogOpen = aclDispatchProps.setRequestPendingDialogOpen,
      setNoAccessDialogOpen = aclDispatchProps.setNoAccessDialogOpen,
      setCustomOnboardingMessage = aclDispatchProps.setCustomOnboardingMessage;

  var resetOnboarding = function resetOnboarding() {
    setOnboardingError(null);
    setOnboardingDialogOpen(false);
    setTokenMailSent(false);
    setRegistrationComplete(false);
    setCustomOnboardingMessage(null);
  };

  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(OnboardingDialog, {
    open: onboardingDialogOpen,
    onClose: resetOnboarding,
    tokenMailSent: tokenMailSent,
    registrationComplete: registrationComplete,
    customOnboardingMessage: customOnboardingMessage,
    onboardingError: onboardingError,
    onRegister: onRegister,
    onLogin: onLogin
  }), /*#__PURE__*/_react["default"].createElement(ShareDialog, _extends({}, shareProfileDialogOpen, {
    handle: setShareProfileDialogOpen
  })), /*#__PURE__*/_react["default"].createElement(RequestDialog, _extends({}, requestDialogOpen, {
    handle: setRequestDialogOpen
  })), /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
    open: requestPendingDialogOpen,
    onClose: function onClose() {
      return setRequestPendingDialogOpen(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.DialogTitle, null, "Toegang in aanvraag"), /*#__PURE__*/_react["default"].createElement(_core.DialogContent, null, "Uw toegang werd aangevraagd en is nog in behandeling. Zodra uw aanvraag werd behandeld, ontvangt u hierover een e-mail."), /*#__PURE__*/_react["default"].createElement(_core.DialogActions, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: function onClick() {
      setRequestPendingDialogOpen(false);
    }
  }, "ok"))), /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
    open: noAccessDialogOpen,
    onClose: function onClose() {
      return setNoAccessDialogOpen(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.DialogTitle, null, "Geen toegang"), /*#__PURE__*/_react["default"].createElement(_core.DialogContent, null, /*#__PURE__*/_react["default"].createElement(_core.Typography, null, "Uw aanvraag werd behandeld, maar u hebt geen toegang op dit document.")), /*#__PURE__*/_react["default"].createElement(_core.DialogActions, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: function onClick() {
      return setNoAccessDialogOpen(false);
    }
  }, "ok"))));
};

ACLDialogs.propTypes = {};
ACLDialogs.defaultProps = {};
var _default = ACLDialogs;
exports["default"] = _default;